"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyOnsiteMessage = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _OnsiteMessageEventingTypes = require("./OnsiteMessageEventingTypes");

var _useOnsiteMessagingImpressionEvent = require("./useOnsiteMessagingImpressionEvent");

var _useOnsiteMessagingIntentToShowEvent = require("./useOnsiteMessagingIntentToShowEvent");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyOnsiteMessage = function EmptyOnsiteMessage(_ref) {
  var eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      gaEventData = _ref.gaEventData;
  var ref = (0, _useOnsiteMessagingImpressionEvent.useOnsiteMessagingImpressionEvent)({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  (0, _useOnsiteMessagingIntentToShowEvent.useOnsiteMessagingIntentToShowEvent)({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    gaEventData: gaEventData
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  });
};

exports.EmptyOnsiteMessage = EmptyOnsiteMessage;
EmptyOnsiteMessage.propTypes = process.env.NODE_ENV !== "production" ? _OnsiteMessageEventingTypes.onsiteMessageEventPropTypes : {};
EmptyOnsiteMessage.defaultProps = _OnsiteMessageEventingTypes.defaultOnsiteMessageEventPropTypes;
/** @component styled-guidist */

var _default = EmptyOnsiteMessage;
exports.default = _default;